import { useCurrentPageAccess } from "@/app/router";
import { Breadcrumbs } from "@/shared/components/layout/Breadcrumbs";
import { PageHeader } from "@/shared/components/layout/PageHeader";
import { DataTable } from "@/shared/components/table";
import { DataTableToolbar } from "@/shared/components/table/DataTableToolbar";
import { Button } from "@/shared/components/ui/button";
import { Card } from "@/shared/components/ui/card";
import { useDialog } from "@/shared/hooks/useDialog";
import { RotateCw } from "lucide-react";
import { useState } from "react";
import { ManualJsonDialog } from "../components/ManualJsonDialog";
import { useDataForwarderRetry } from "../hooks/useDataForwarderRetry";
import { useDataForwarderRetryColumns } from "../hooks/useDataForwarderRetryColumns";
import type { DataForwarderRetryRow } from "../types/recover-types";

export function RecoverDataForwarderReprocessPage() {
  const vm = useDataForwarderRetry();
  const columns = useDataForwarderRetryColumns();
  const { canWriteCurrentPage } = useCurrentPageAccess();
  const [selectedRows, setSelectedRows] = useState<DataForwarderRetryRow[]>([]);
  const jsonDialog = useDialog<void>();

  return (
    <div className="space-y-6">
      <Breadcrumbs />
      <PageHeader title="데이터 포워더 재처리" description="데이터 포워딩 과정에서 오류가 발생한 경우를 재시도합니다." />

      {vm.result && (
        <Card className="p-4">
          <pre className="whitespace-pre-wrap text-sm">{vm.result.message}</pre>
        </Card>
      )}

      <DataTable
        columns={columns}
        data={vm.rows}
        totalCount={vm.rows.length}
        page={1}
        pageSize={50}
        enableRowSelection
        rowSelectionTrigger="checkbox"
        getRowId={(row) => row.transId}
        onRowSelectionChange={setSelectedRows}
        toolbar={
          <DataTableToolbar
            actions={
              <>
                <Button variant="outline" onClick={vm.reload} disabled={vm.isLoading}>
                  <RotateCw className="mr-2 h-4 w-4" />
                  새로고침
                </Button>

                <Button
                  onClick={() => vm.resendSelected(selectedRows.map((r) => r.transId))}
                  disabled={!canWriteCurrentPage || selectedRows.length === 0 || vm.isLoading}
                >
                  재전송
                </Button>

                <Button variant="outline" onClick={() => jsonDialog.open()} disabled={vm.isLoading}>
                  JSON 직접 입력
                </Button>
              </>
            }
          />
        }
      />

      <ManualJsonDialog
        open={jsonDialog.isOpen}
        onOpenChange={(open) => !open && jsonDialog.close()}
        onSubmit={vm.sendManualJson}
      />
    </div>
  );
}